module.exports = __webpack_public_path__ + "static/img/IMG_20170905_183223.5f2a7316.jpg";